import React, { useMemo } from 'react';
import SingleSelect, { ISingleSelectOption } from 'ui/SingleSelect';
import { userToOption } from 'ui/SingleSelect/helpers';
import classnames from 'classnames';
import { ITravelAgentResponse } from 'services/BackendApi';
import { useResponsive } from '../hooks/useResponsive';

interface ISalesUserSelectProps {
  isAdmin: boolean;
  salesUserId: string | undefined;
  salesUsers: { data: ITravelAgentResponse };
  isLoadingSalesUsers: boolean;
  onSalesUserIdChange: (salesUserId: string | undefined) => void;
}

export const SalesUserSelect: React.FC<ISalesUserSelectProps> = ({ isAdmin, salesUserId, salesUsers, isLoadingSalesUsers, onSalesUserIdChange }) => {
  const hasSalesUsers = salesUsers && salesUsers?.data?.data?.length > 0;
  const { isMobile } = useResponsive();

  const salesUserOptions: ISingleSelectOption[] = useMemo(() => salesUsers?.data?.data?.map(user => userToOption(user)) ?? [], [salesUsers]);
  const sortedSalesUserOptions = useMemo(() => salesUserOptions.sort((a, b) => a.label?.localeCompare(b.label ?? '') ?? 0), [salesUserOptions]);
  const className = classnames('m-0 mb-[5px] font-pt-sans text-[13px] text-black tracking-[0.52px] leading-[19px]', {
    'min-w-[250px]': !isMobile,
    'min-w-[155px] max-w-[155px]': isMobile,
  });

  return (
    <div className="sales-user-select flex flex-col">
      {isAdmin && (
        <div className="max-w-[400px]">
          <p className={className}>Dashboard of...</p>
          {isAdmin && hasSalesUsers ? (
            <SingleSelect
              fieldId="sales-user-select"
              value={salesUserId}
              options={sortedSalesUserOptions}
              onChange={onSalesUserIdChange}
              labelWhenNothingSelected="Select a sales user"
              loading={isLoadingSalesUsers}
              showSelectedOption
            />
          ) : (
            <p className="m-0 font-pt-sans text-[13px] text-black tracking-[0.52px]">No sales users found</p>
          )}
        </div>
      )}
    </div>
  );
};
